import { getTrackers } from "@base/config";
import { getTrackerStatus, TRACKER_NAMES, TrackerName, TrackerStatus } from "./trackers";

/** Whether a tracker runs in this build (see the app's src/trackers.ts). */
export function isTrackerOn(name: TrackerName): boolean {
  return getTrackerStatus(getTrackers(), name).on;
}

export function getAllTrackerStatuses(): TrackerStatus[] {
  const trackers = getTrackers();
  return TRACKER_NAMES.map((name) => getTrackerStatus(trackers, name));
}
